import React, { useContext, useState } from "react";
import "../../../css/home/home.css"; // Asegúrate de crear este archivo CSS también
import ColorsMain from "../../../colors/ColorsMain";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../button/ButtonWhite";
import ButtonCheckBox from "../../button/ButtonCheckBox";

const ServiceColurs = ({ activity, toggleStatus, onClick, errorMesagge = false }) => {
    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const showAlert = (message) => {
        alert(message);
    };
    console.log("activitiesxdddd", activity[0].status);

    return (
        <div
            style={{ color: ColorsMain.texttMain }}
            className="flex justify-evenly flex-col gap-2 w-full"
        >
            <div className="flex flex-col">
                <p className="text-2xl md:text-3xl mt-6 md:mt-8" style={{ fontFamily: "brico" }}>
                    {GLOBAL_LANGUAGE[language].service_colurs.title}
                </p>
                <p className="text-[#E4E4E4] text-[14px] mt-2 mb-6 md:mb-8">
                    {GLOBAL_LANGUAGE[language].service_colurs.description}
                </p>
                <div className="gap-2 flex flex-col">
                    <ButtonCheckBox onClick={() => toggleStatus(1)} status={activity[0].status} label={GLOBAL_LANGUAGE[language].service_colurs.service1} />
                    <ButtonCheckBox onClick={() => toggleStatus(2)} status={activity[1].status} label={GLOBAL_LANGUAGE[language].service_colurs.service2} />
                    <ButtonCheckBox onClick={() => toggleStatus(3)} status={activity[2].status} label={GLOBAL_LANGUAGE[language].service_colurs.service3} />
                    <ButtonCheckBox onClick={() => toggleStatus(4)} status={activity[3].status} label={GLOBAL_LANGUAGE[language].service_colurs.service4} />
                    <ButtonCheckBox onClick={() => toggleStatus(5)} status={activity[4].status} label={GLOBAL_LANGUAGE[language].service_colurs.service5} />
                    <ButtonCheckBox onClick={() => toggleStatus(6)} status={activity[5].status} label={GLOBAL_LANGUAGE[language].service_colurs.service6} />
                </div>
                {errorMesagge && (
                    <div className="w-full flex flex-col mt-1">
                        <p className="text-[#FF928B] text-[13px]">{GLOBAL_LANGUAGE[language].service_colurs.error_service_colurs}</p>
                    </div>
                )}
                <div className="flex flex-row justify-end mb-1 mt-4">
                    <ButtonWhite
                        onClick={() => onClick()}
                        label={GLOBAL_LANGUAGE[language].service_colurs.label_button}
                        className="w-full md:w-fit"
                    />
                </div>
            </div>
        </div>
    );
};

export default ServiceColurs;
